<template>
  <div class="scroll_top">
    <div class="scroll_top__container">
      <span class="text" @click="goTop()"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'scroll-top',
  props: {
  },
  methods: {
    goTop(){
      $('html,body').animate({scrollTop:0})
    }
  }
}</script>

<style lang="scss">
@import "../../../sass/variables/layout.scss";
.scroll_top{
  position: relative;
  height: 40px;
  z-index: 10;
  width: 1020px;
  margin: auto;
  align-items: center;
  justify-items: center;
  place-items: center;
  overflow: hidden;
  padding: 0 16px 0 16px ;
  margin-bottom: 64px;
  @media screen and (max-width: $breakpoint) {
    max-width: 580px;
    min-width: 320px;
    margin-bottom: 32px;
  }
  @media screen and (max-width: 1020px ) {
    width: 100%;
  }
  &__container {
    margin: auto;
    position: relative;
    min-height: auto;
    .text {
      position: absolute;
      cursor: pointer;
      right: 0;
      background: rgba(14, 14, 14, 1);
      border-radius: 26px;
      color: white;
      width: 125px;
      height: 40px;
      text-align: center;
      line-height: 39px;
      font-weight: bold;
      @media screen and (max-width: $breakpoint) {
//        background: rgba(20, 20, 20, 0.75);
//        text-indent: 1.5em;
//        width: 40px;
      }

      &:after{
        font-family: "source-han-sans-japanese";
        font-weight: 300;
        content: '▲ トップへ戻る';
        @media screen and (max-width: $breakpoint) {
//          background-image: url('/static/img/common/arrow_up_white.png');
//          content: '';
//          width: 16px;
//          top: 12px;
//          left: 12px;
//          position: absolute;
        }
        font-size: 13px;
        line-height: 13px;
        background-repeat: no-repeat;
        background-position: center;
        background-size: auto 100%;
        height: 16px;
        width: 125px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/ScrollTop.vue